import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

import { changePage, Html5AppAction } from './actions';
import { Html5App, Html5AppProps, OwnProps } from './Html5App';
import { Html5Page } from './typings';

export type StateProps = TStateProps<Html5AppProps>;

export type DispatchProps = TDispatchProps<Html5AppProps, OwnProps>;
const mapDispatchToProps = (dispatch: Dispatch<Html5AppAction>): DispatchProps => {
    return {
        changePage: (page: Html5Page) => dispatch(changePage(page))
    };
};

export const mapStateToProps = (state: State): StateProps => {
    return state.canvasEditor.html5;
};

export const Html5AppContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(Html5App);
